export default {
  errorLogs: (state) => state.errorLogs,
  loading: (state) => state.loading,
};
